import { useCallback, useEffect, useState } from "react";
import { useFormik } from "formik";

import {
  Box,
  Container,
  Grid,
  Button,
  CardContent,
  CardHeader,
  Card,
} from "@material-ui/core";

import ClearButton from "components/_refactor/button/clear";
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import PeriodField from "components/_refactor/fields/period-field";
import Api from "lib/api/httpRequestHelper";
import LoadingData from "components/Loading/LoadingData";
import TableLogsDeErro from "./table/TableLogsDeErro";
import useStructureQueries from "hooks/useStructureQueries";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import { IsMobile, IsMobile500, IsMobile900 } from "utils/is-mobile";

const sistemaOptions = [
  { value: "APP", name: "APP" },
  { value: "PORTALB2B", name: "B2B" },
];

const tipoLogOptions = [
  { value: "ERRO-EXECECAO", name: "Erro Exceção" },
  { value: "ERRO-INTEGRACAO", name: "Erro Integração" },
  { value: "REGRA-NEGOCIO", name: "Regra de Negócio" },
  { value: "TODOS", name: "Todos" },
];

function LogsDeErro() {
  const snackbar = useSnackbar();
  const [logs, setLogs] = useState(null);
  const [fetchingApis, setFetchingApis] = useState(false);

  const [searching, setSearching] = useState(false);
  const [apisList, setApisList] = useState([]);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [systemOption, setSystemOption] = useState("PORTALB2B");
  const [systemType, setType] = useState("TODOS");

  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(25);

  const isMobile = IsMobile500();

  const isMobile900 = IsMobile900();

  const isMobile700 = IsMobile();

  const { getLogApiScreenList } = useStructureQueries();

  const fetchApiList = useCallback(async () => {
    setFetchingApis(true);
    try {
      const result = await getLogApiScreenList();
      setApisList(result?.data ?? []);
    } catch (e) {
      snackbar.showMessage(e, {
        severity: "error",
      });    } finally {
      setFetchingApis(false);
    }
  }, [snackbar, getLogApiScreenList]);

  const handleSearch = async ({ page = 1, sizePerPage = 25 }) => {
    const { apis, periodo, dataInicial, dataFinal } = values;

    setSearching(true);
    setCancelLoading(false);

    await Api.get(
      "log-system-list",
      "log",
      `?page=${page - 1}&pageSize=${sizePerPage}` +
        "&sistema=" +
        systemOption +
        (periodo ? `&dtIni=${dataInicial}&dtFim=${dataFinal}` : "") +
        (systemType !== "TODOS" ? `&tipo=${systemType}` : "") +
        (apis?.Nome ? `&api=${apis?.Nome}` : ""),
      true
    )
      .then((res) => {
        if (res?.Result?.Logs !== 0) {
          const newLogsList = [];

          res?.Result?.Logs?.map((option) => {
            const newObject = {
              dataFormat: option?.DataFormat,
              mensagem: option?.Mensagem,
              usuario: option?.Usuario,
              sistema: option?.Sistema,
              id: Math.floor(Math.random() * (100000 - 5000 + 1)) + 5000,
              parametros: option?.ParametroEnvio,
            };
            newLogsList.push(newObject);
          });
          setLogs(newLogsList);
        }
        setCurrentPage(page);
        setCurrentSizePerPage(sizePerPage);
        setTotalRegisters(res.Result.TotalRegistro);
        setSearching(false);
      })
      .catch((error) => {
        setSearching(false);
        setErrorMessage(true);
        console.log(error);      })
      .finally(() => {
        setSearching(false);
      });
  };

  const formik = useFormik({
    initialValues: {
      apis: "",
      periodo: null,
      dataInicial: null,
      dataFinal: null,
    },
  });

  const { values, handleChange } = formik;

  const getDefaultApi = useCallback(
    (Nome) => {
      return apisList?.find((api) => api.Nome === Nome);
    },
    [apisList]
  );

  const handleClearFilters = () => {
    setClearFilters(true);
    setSearching(true);
    handleChange({
      target: {
        name: "periodo",
        value: null,
      },
    });
    handleChange({
      target: {
        name: "dataInicial",
        value: null,
      },
    });
    handleChange({
      target: {
        name: "dataFinal",
        value: null,
      },
    });
    handleChange({
      target: {
        name: "apis",
        value: "",
      },
    });
    setType("TODOS");
    setSystemOption("PORTALB2B");
    setSearching(false);
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setLogs(null);
  };

  useEffect(() => {
    if (errorMessage && !cancelLoading) {
      snackbar.showMessage(
        "Ocorreu um erro ao buscar logs de erro. Verifique os parâmetros informados e/ou tente novamente mais tarde.",
        {
          severity: "error",
        }
      );
    }
  }, [cancelLoading, errorMessage]);

  useEffect(() => {
    if (values?.periodo === null && values?.apis === "" && clearFilters) {
      setClearFilters(false);
    }
  }, [values, clearFilters]);

  useEffect(() => {
    fetchApiList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <HeaderClientes section="Logs de Erro" subsection="Administração" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Filtros"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              ></CardHeader>
              <CardContent>
                <>
                  <Grid container spacing={2}>
                    <Grid item xs={isMobile700 ? 12 : isMobile900 ? 6 : 4}>
                      <AutoCompleteField
                        options={apisList}
                        label="API"
                        onChange={(value) => {
                          handleChange({
                            target: { name: "apis", value },
                          });
                        }}
                        optionLabelKey="Descricao"
                        optionIdKey="Nome"
                        value={() => getDefaultApi(values.apis?.Nome)}
                        disabled={searching || fetchingApis}
                        loading={searching || clearFilters}
                      />
                    </Grid>
                    <Grid item xs={isMobile700 ? 12 : isMobile900 ? 6 : 4}>
                      <AutoCompleteField
                        label="Sistema"
                        required
                        options={sistemaOptions}
                        optionLabelKey="name"
                        optionIdKey="value"
                        value={
                          sistemaOptions.find(
                            (item) => item.value === systemOption
                          ) || null
                        }
                        disabled={searching}
                        onChange={(newValue) => {
                          setSystemOption(newValue ? newValue.value : "");
                        }}
                      />
                    </Grid>
                    <Grid item xs={isMobile700 ? 12 : isMobile900 ? 6 : 4}>
                      <AutoCompleteField
                        label="Tipo de Log"
                        required
                        options={tipoLogOptions}
                        optionLabelKey="name"
                        optionIdKey="value"
                        value={
                          tipoLogOptions.find(
                            (item) => item.value === systemType
                          ) || null
                        }
                        disabled={searching}
                        onChange={(newValue) => {
                          setType(newValue ? newValue.value : "");
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={values.periodo?.value === "Outros" ? "12" : 4}
                    >
                      <PeriodField
                        label="Período"
                        value={values.periodo}
                        onChange={(option) => {
                          handleChange({
                            target: { name: "periodo", value: option },
                          });
                        }}
                        initialDate={values.dataInicial}
                        finalDate={values.dataFinal}
                        setInitialDate={(value) => {
                          handleChange({
                            target: { name: "dataInicial", value },
                          });
                        }}
                        setFinalDate={(value) => {
                          handleChange({
                            target: { name: "dataFinal", value },
                          });
                        }}
                        disabled={searching}
                      />
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={isMobile700 ? 12 : isMobile900 && 6}>
                      <Button
                        style={
                          isMobile || isMobile900
                            ? {
                                width: "100%",
                                marginBottom: "0.75rem",
                                marginTop: "0.75rem",
                              }
                            : { marginBottom: "0rem" }
                        }
                        color="default"
                        variant="contained"
                        onClick={() => {
                          handleSearch({
                            page: 1,
                            sizePerPage: 25,
                          });
                        }}
                        disabled={searching || fetchingApis}
                      >
                        {searching ? "Pesquisando..." : "Pesquisar"}
                      </Button>
                    </Grid>
                    <Grid
                      item
                      xs={isMobile700 ? 12 : isMobile900 && 6}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <ClearButton
                        fullWidth={true}
                        disabled={searching || fetchingApis}
                        onClick={() => handleClearFilters()}
                      />
                    </Grid>
                  </Grid>
                </>
              </CardContent>
            </Card>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              label="Buscando dados..."
            />
          </Grid>
          {Boolean(logs) && !searching && !cancelLoading && (
            <Grid item xs={12}>
              <TableLogsDeErro
                dataTable={logs}
                totalRegisters={totalRegisters}
                currentPage={currentPage}
                currentSizePerPage={currentSizePerPage}
                handleSearch={handleSearch}
                searching={searching}
              />
            </Grid>
          )}
        </Grid>
      </Container>
    </>
  );
}

LogsDeErro.propTypes = {};

export default LogsDeErro;
